import { Button } from '@basqet-dashboard/common/components';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { ReUploadModal } from './reupload';

const ReasonForRejection = ({ documentTitle, comments, reference }) => {
  const [showUploadModal, setUploadModal] = useState(false);

  const openReuploadModal = () => setUploadModal(true);
  const closeReuploadModal = () => setUploadModal(false);

  return (
    <div className="kyc__comment">
      <h4>Reason(s) for Decline: </h4>
      <div className="kyc__comment__reasons">
        {comments.map((comment, index) => {
          return <p key={`reason-for-rejection-${index}`}>{comment?.reason}</p>;
        })}
      </div>
      <div className="kyc__comment__button__container">
        <Button size="small" onClick={openReuploadModal}>
          Reupload
        </Button>
      </div>
      {showUploadModal && (
        <ReUploadModal
          documentTitle={documentTitle}
          reference={reference}
          onModalClose={closeReuploadModal}
        />
      )}
    </div>
  );
};

ReasonForRejection.propTypes = {
  comments: PropTypes.array,
  documentTitle: PropTypes.string,
  reference: PropTypes.string
};

export { ReasonForRejection };
